import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2'
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout'

export const BENEFITS = [
  'Nielimitowany dostęp do kursów grupowych AlgoAcademy - zapisy na kursy są bezpłatne dla mentorowanych',
  'Indywidualny plan rozwoju dostosowany do Twoich umiejętności, celów, i zainteresowań oraz nielimitowaną możliwość aktualizacji',
  'Regularne konsultacje z mentorem co 2 tygodnie',
  'Zadania i projekty indywidualnie dobrane przez mentora',
  'Nielimitowany kontakt z mentorem przez czat (czas oczekiwania na odpowiedź do 48 godzin)',
  'Regularne monitorowanie postępów'
]

export function BasicMentoringOptions() {
  return (
    <section className='space-y-4'>
      {BENEFITS.map(text => (
        <IconOnTheLeftWithContentLayout
          key={text}
          mainContent={<P2 className='text-contentSecondary'>{text}</P2>}
        />
      ))}
    </section>
  )
}
